// import { store } from '../config/auth/store';
// import { logout } from '../config/auth/userSlice';
// import { URL_PREFIX } from '../constants/stores';

// type ApiOptions = {
//   method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
//   body?: unknown;
//   headers?: Record<string, string>;
// };

// class ApiError extends Error {
//   status: number;
//   data: any;

//   constructor(message: string, status: number, data?: any) {
//     super(message);
//     this.status = status;
//     this.data = data;
//   }
// }

// /**
//  * Gets token directly from Redux store.
//  * This avoids calling useSelector inside every page.
//  */
// const getAuthToken = () => {
//   return store.getState().user.sessionId;
// };

// /**
//  * Main API request helper.
//  * Automatically adds:
//  * - Content-Type
//  * - Authorization bearer token
//  * - JSON body
//  * - common error handling
//  */
// const request = async <T>(endpoint: string, options: ApiOptions = {}): Promise<T> => {
//   const token = getAuthToken();

//   const response = await fetch(`${URL_PREFIX}${endpoint}`, {
//     method: options.method || 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       ...options.headers,
//     },
//     body: options.body ? JSON.stringify(options.body) : undefined,
//   });

//   const data = await response.json().catch(() => null);

//   if (!response.ok) {
//     if (response.status === 401 || response.status === 400) {
//       const message = data?.message || '';

//       if (
//         message.toLowerCase().includes('authentication failed') ||
//         message.toLowerCase().includes('token')
//       ) {
//         store.dispatch(logout());
//       }
//     }

//     throw new ApiError(
//       data?.message || 'Something went wrong.',
//       response.status,
//       data
//     );
//   }

//   return data as T;
// };

// export const apiClient = {
//   get: <T>(endpoint: string) =>
//     request<T>(endpoint, { method: 'GET' }),

//   post: <T>(endpoint: string, body?: unknown) =>
//     request<T>(endpoint, { method: 'POST', body }),

//   put: <T>(endpoint: string, body?: unknown) =>
//     request<T>(endpoint, { method: 'PUT', body }),

//   delete: <T>(endpoint: string, body?: unknown) =>
//     request<T>(endpoint, { method: 'DELETE', body }),
// };

// export { ApiError };
//api.ts
import { store } from '../config/auth/store';
import { logout } from '../config/auth/userSlice';
import { URL_PREFIX } from '../constants/stores';

type ApiOptions = {
method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
body?: unknown;
headers?: Record<string, string>;
};

class ApiError extends Error {
status: number;
data: any;

constructor(message: string, status: number, data?: any) {
super(message);
this.status = status;
this.data = data;
}
}

/**
* Gets token directly from Redux store.
* This avoids calling useSelector inside every page.
*/
const getAuthToken = () => {
return store.getState().user.sessionId;
};

/**
* Main API request helper.
* Automatically adds:
* - Content-Type
* - Authorization bearer token
* - JSON body
* - common error handling
*/
const request = async <T>(endpoint: string, options: ApiOptions = {}): Promise<T> => {
const token = getAuthToken();

const response = await fetch(`${URL_PREFIX}${endpoint}`, {
method: options.method || 'GET',
headers: {
'Content-Type': 'application/json',
...(token ? { Authorization: `Bearer ${token}` } : {}),
...options.headers,
},
body: options.body ? JSON.stringify(options.body) : undefined,
});

const data = await response.json().catch(() => null);

if (!response.ok) {
if (response.status === 401 || response.status === 400) {
const message = data?.message || '';

if (
message.toLowerCase().includes('authentication failed') ||
message.toLowerCase().includes('token')
) {
store.dispatch(logout());
}
}

throw new ApiError(
data?.message || 'Something went wrong.',
response.status,
data
);
}

return data as T;
};
// src/api/queryString.ts

export const buildQueryString = (params?: Record<string, any>) => {
if (!params) return '';

const searchParams = new URLSearchParams();

Object.entries(params).forEach(([key, value]) => {
if (value !== undefined && value !== null && value !== '') {
searchParams.append(key, String(value));
}
});

const queryString = searchParams.toString();

return queryString ? `?${queryString}` : '';
};

const formRequest = async <T>(
endpoint: string,
formData: FormData,
options: Omit<ApiOptions, 'body' | 'headers'> & {
headers?: Record<string, string>;
} = {}
): Promise<T> => {
const token = getAuthToken();

const response = await fetch(`${URL_PREFIX}${endpoint}`, {
method: options.method || 'POST',
headers: {
...(token ? { Authorization: `Bearer ${token}` } : {}),
...options.headers,
},
body: formData,
});

const data = await response.json().catch(() => null);

if (!response.ok) {
if (response.status === 401 || response.status === 400) {
const message = data?.message || '';

if (
message.toLowerCase().includes('authentication failed') ||
message.toLowerCase().includes('token')
) {
store.dispatch(logout());
}
}

throw new ApiError(
data?.message || 'Something went wrong.',
response.status,
data
);
}

return data as T;
};

export const apiClient = {
get: <T>(endpoint: string) =>
request<T>(endpoint, { method: 'GET' }),

post: <T>(endpoint: string, body?: unknown) =>
request<T>(endpoint, { method: 'POST', body }),

put: <T>(endpoint: string, body?: unknown) =>
request<T>(endpoint, { method: 'PUT', body }),

delete: <T>(endpoint: string, body?: unknown) =>
request<T>(endpoint, { method: 'DELETE', body }),

form: <T>(endpoint: string, formData: FormData) =>
formRequest<T>(endpoint, formData, { method: 'POST' }),
};

export { ApiError };